/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Trainer_Pricing_DescriptionInputs */

const en_seo_trainer_pricing_description = /** @type {(inputs: Seo_Trainer_Pricing_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: prices for sessions, packs and plans. Book online.`)
};

const pl_seo_trainer_pricing_description = /** @type {(inputs: Seo_Trainer_Pricing_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: ceny zajęć, karnetów i planów. Zarezerwuj online.`)
};

/**
* | output |
* | --- |
* | "{name}: prices for sessions, packs and plans. Book online." |
*
* @param {Seo_Trainer_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_trainer_pricing_description = /** @type {((inputs: Seo_Trainer_Pricing_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Trainer_Pricing_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_trainer_pricing_description(inputs)
	return en_seo_trainer_pricing_description(inputs)
});